import { createAsyncThunk } from "@reduxjs/toolkit";
import noticeApi from "api/noticeApi";
import { formatQueryParams } from "helpers/format";

export const getNotice = createAsyncThunk(
  "Notice",
  async (params: any = {}) => {
    try {
      const response = await noticeApi.getNotice(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const createNotice = async (data: any = {}) => {
  try {
    const response = await noticeApi.postNotice(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateNotice = async (id: string | number, data: any = {}) => {
  try {
    const response = await noticeApi.putNotice(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
